import { TDashboardMenuItem } from "../../navigation/dashboardSideMenu";

export type GlobalSearchPayload = {
  search: string;
};

export enum GlobalSearchResponseTypes { // values being used for translations
  HELP_ARTICLE="HELP_ARTICLE",
  REPORT = "REPORT",
  PAGE = "PAGE", // any page on the app
}

export type GlobalSearchResponseItem = {
  id: number;
  name: string;
  search_type: GlobalSearchResponseTypes;
  uri?: string;
  slug?:string;
};

export type GlobalSearchResponse = GlobalSearchResponseItem[];

export enum GlobalSearchResultDisplayItemSources {
  GLOBAL_SEARCH = 'global_search',
  DASHBOARD_MENU = 'dashboard_menu',
  DASHBOARD_ADMINS_MENU = 'dashboard_admins_menu',
  PAGE = 'page', // any page on the app
}

export type GlobalSearchResultDisplayItem = {
  display_title_for_sorting: string;
  object: GlobalSearchResponseItem | TDashboardMenuItem;
  source: GlobalSearchResultDisplayItemSources;
};